import styles from "../AudioRecorder.module.scss";
import { Button } from "react-bootstrap";
import { ReactComponent as PauseIcon } from "assets/svg/pause-icon.svg";
import { ReactComponent as ResumeIcon } from "assets/svg/play-icon.svg";
import { ReactComponent as RadioButtonWithBorder } from "assets/svg/outline-radio-button.svg";
import SoundWaveAnimation from "../audioVisualizer/SoundWaveAnimation";
import RecordingDescription from "./RecordingDescription";
import RecordingStatus from "./RecordingStatus";
import RecordingTimer from "./RecordingTimer";

const InPersonControls = ({
  appointment,
  recordingError,
  isPaused,
  isRecordingFinished,
  isRecordingStarted,
  mediaRecorderRef,
  setIsPaused,
  getCurrentInputVolume,
  recordingTimeString,
}) => {
  const handleToggleRecording = () => {
    if (!mediaRecorderRef.current) return;

    if (isPaused) {
      mediaRecorderRef.current.resume();
      setIsPaused(false);
    } else {
      mediaRecorderRef.current.pause();
      setIsPaused(true);
    }
  };

  const getButtonContent = () => {
    if (!isRecordingStarted) {
      return (
        <>
          <RadioButtonWithBorder /> Getting Started
        </>
      );
    }

    if (isPaused) {
      return (
        <>
          <ResumeIcon /> Resume
        </>
      );
    }

    return (
      <>
        <PauseIcon /> Pause
      </>
    );
  };

  return (
    <div className={styles["audio-recorder__center-bottom"]}>
      <div className={styles["audio-recorder__recording-text"]}>
        <RecordingStatus
          recordingError={recordingError}
          isPaused={isPaused}
          isRecordingFinished={isRecordingFinished}
          isRecordingStarted={isRecordingStarted}
        />
      </div>
      <RecordingTimer
        recordingTimeString={recordingTimeString}
        isRecordingStarted={isRecordingStarted}
        isPaused={isPaused}
      />

      <div className={styles["audio-recorder__title"]}>
        {appointment?.session_recording_type === "dictation"
          ? "Dictation Tips"
          : "Audio Recorder"}
      </div>

      <RecordingDescription
        isPaused={isPaused}
        appointment={appointment}
        recordingError={recordingError}
      />

      {!recordingError && (
        <SoundWaveAnimation
          getCurrentInputVolume={getCurrentInputVolume}
          isRecordingStarted={isRecordingStarted}
          isPaused={isPaused}
        />
      )}

      <Button
        className={styles["audio-recorder__toggle-button"]}
        onClick={handleToggleRecording}
      >
        {getButtonContent()}
      </Button>
    </div>
  );
};

export default InPersonControls;
